import type { User } from '@/types/api';

// O fluxo antigo de Kanban/Pedidos fica restrito a SUPERADMIN/ADMIN e à conta
// legada que ainda depende dele (marcada via UserProfile.meta.legacyKanban).
// Todo o restante do produto usa o novo fluxo de marketplace.
export const hasLegacyKanbanAccess = (user: User | null | undefined): boolean => {
  if (!user) return false;
  if (user.role === 'SUPERADMIN' || user.role === 'ADMIN') return true;
  return user.profile?.meta?.legacyKanban === true;
};

// URL do app legado independente (ex.: "/v1/"). Definida só no build da virada; sem ela
// nada é redirecionado e o comportamento permanece o de antes.
export const LEGACY_APP_URL: string | undefined = import.meta.env.VITE_LEGACY_APP_URL || undefined;

// Conta que só existe para usar o Kanban antigo (flag legacyKanban, sem papel de admin da
// plataforma). Quando o app legado independente está ativo, essas contas passam a usá-lo.
export const isMigratedLegacyAccount = (user: User | null | undefined): boolean => {
  if (!user || !LEGACY_APP_URL) return false;
  if (user.role === 'SUPERADMIN' || user.role === 'ADMIN') return false;
  return user.profile?.meta?.legacyKanban === true;
};
